import styled from 'styled-components';

export const DesktopButtonRow = styled.div`
  /* position: fixed;
  top: 64px;
  right: 40px; */
  z-index: 2;
  @media (max-width: 767px) {
    display: none;
  }
`;
